import React from "react";
import { Provider } from "react-redux";
import "./publicPathLoader";
import "regenerator-runtime/runtime";
import { IntlProvider } from "react-intl";
import { LanguageSwitcherSelectors } from "./redux/selectors";
import ReactDOM from "react-dom";
import { UIUtils } from "./utils";

export const renderApplication = async (criticalPromises, AppComponent) => {
  if (UIUtils.isClientMode()) return;

  criticalPromises.then(promiseResults => {
    setTimeout(() => {
      const store = promiseResults[0]; //storePromise
      const messages = promiseResults[1]; //localePromise

      const language = LanguageSwitcherSelectors.lang(store.getState()) || "en";
      const rootElement = document.getElementById("uc-wrapper-container");
      if (!rootElement)
        throw new Error(
          "Missing root container (uc-wrapper-container). Cannot render the Userarea React App."
        );

      rootElement.classList.add("visible--el");

      const root = ReactDOM.createRoot(rootElement);

      root.render(
        <IntlProvider
          locale={language}
          messages={messages}
          textComponent={React.Fragment}
        >
          <Provider store={store}>
            <AppComponent />
          </Provider>
        </IntlProvider>
      );
    });
  }, 0);
};
